import CopiableTag from "common/components/CopiableTag";

import IntegrationAccountField from "./IntegrationAccountField";
import IntegrationSettingsError from "./IntegrationSettingsError";
import RemoveIntegrationButton from "./RemoveIntegrationButton";
import SettingsContainer from "./SettingsContainer";

import type { JSX } from "react";

type SmartleadAndInstantlySettingsProps =
  | ({ type: "instantly" } & (
      | { workspaceName: string }
      | { errorMessage: string }
    ))
  | { type: "smartlead"; apiKey: string };

export default function SmartleadAndInstantlySettings(
  props: SmartleadAndInstantlySettingsProps,
) {
  const { type } = props;

  let content: JSX.Element;

  if ("errorMessage" in props) {
    content = <IntegrationSettingsError errorMessage={props.errorMessage} />;
  } else if (type === "instantly") {
    content = (
      <IntegrationAccountField
        label="Instantly workspace"
        value={props.workspaceName}
      />
    );
  } else {
    content = (
      <div className="flex items-center gap-x-1.5 justify-between">
        <h4 className="text-button-xs">Smartlead API key</h4>
        <CopiableTag value={props.apiKey} />
      </div>
    );
  }

  return (
    <SettingsContainer integrationKey={type}>
      {content}
      <RemoveIntegrationButton integrationKey={type} />
    </SettingsContainer>
  );
}
